<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tUc0V2/tc-custom/9781398474390.jpg?1705766066903" alt="This image is the cover for the book The Bear's Cage Unlocked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Bear's Cage Unlocked
      </h1>
      <p class="bookDescription body article font2">
        <p>It is 2041, 10 years after the Iran-Israeli nuclear war. The Gulf is a radioactive wasteland. Fires continue to burn out of control and a warm blanket of smog envelops the earth. Sea levels rise as the polar ice melts. The world economy has stuttered to a halt. The UK emergency government continues in power, self-interested, unelected, and corrupt. Repression triggers a backlash from the radical groups, and 10 years of bitter civil war follow. A new radical group is funding the armed struggle and is seeking a showdown. Mary Brand, head of counterintelligence for the main rebel group wants to restart the democratic process. Bryan Sansom, section chief at MI5 sees a chance for peace and works with Sarah Chilcott Minister for National Defence to bring the opposition in from the cold. Sansom is desperate to find out who is bankrolling the opposition groups. Time is beginning to run out. Richard Smart, Minister for Homeland Security is determined to impose order at all costs terrified by the spectre of Easter Island Syndrome where a society turns in on itself and begins to self-destruct. He believes all opposition must be crushed before the nation can be reborn. Brand and Chilcott are relying on the bravery of Jon Grogan a troubled ex-soldier to bring sanity back to the world, helped by Sukri Chakraborty an MI5 agent. An attack on the new Thames Gateway Barrier on the eve of a tidal surge from the North Sea threatens to derail the peace process and devastate London.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew MacMichael
      </h2>
      
      <p class="authorDescription body article">Andrew MacMichael lives and works in the West Midlands with his wife, five cats and numerous children. Before writing speculative science fiction, he worked initially as a lawyer, and later in the accountancy profession. Andrew became interested in climate change whilst at Southampton University studying environmental law. He believes that mankind is now faced with a stark ultimatum—adapt or face extinction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54750c53